const STORAGE_PREFIX = 'ideoz:wbt:built-turns:v1:';

function storageKey(conversationId: string): string {
  return `${STORAGE_PREFIX}${conversationId}`;
}

export function readBuiltTurnIds(conversationId: string | undefined): Set<string> {
  if (!conversationId || typeof sessionStorage === 'undefined') {
    return new Set();
  }
  try {
    const raw = sessionStorage.getItem(storageKey(conversationId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id): id is string => typeof id === 'string' && id.length > 0));
  } catch {
    return new Set();
  }
}

export function writeBuiltTurnIds(conversationId: string | undefined, ids: ReadonlySet<string>): void {
  if (!conversationId || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(storageKey(conversationId), JSON.stringify([...ids]));
  } catch {
    /* ignore quota */
  }
}

export function addBuiltTurnId(conversationId: string | undefined, llmInteractionId: string): Set<string> {
  const next = readBuiltTurnIds(conversationId);
  next.add(llmInteractionId);
  writeBuiltTurnIds(conversationId, next);
  return next;
}
